const trains = {
  train: "Trein", // translated
  trains: "Treinen", // translated
  fairConditions: "Eerlijke voorwaarden", // translated
  to: "naar", // translated
  earlier: "Eerder", // translated
  later: "Later", // translated
  adults: "Volwassenen", // translated
  child: "Kind", // translated
  senior: "Senior", // translated
  seniors: "Senioren", // translated
  price: "Prijs", // translated
  for: "voor", // translated
  total: "Totaal", // translated
  selected: "Geselecteerd", // translated
  prebook: "Voorboeking", // translated
  book: "Boek", // translated
  payment: "Betaling", // translated
  return: "Opbrengst", // translated
  passengers: "Passagiers", // translated
  delivery: "Levering", // translated
  summary: "Samenvatting", // translated
  checkout: "Uitchecken", // translated
  trainToastCorrectFillForm: "Vul alle velden correct in.", // translated
  fareConditions: "Tariefvoorwaarden", // translated
  travelInfo: "Reisinformatie", // translated
  remarks: "Opmerkingen van klanten", // translated
  noServices: "Geen diensten", // translated
  timesAndSeats: "Tijden en zitplaatsen", // translated
  mobileTicket: "Mobiel kaartje", // translated
  stationTicket: "Ophalen op station", // translated
  homeTicket: "Thuis afdrukken", // translated
  countryCode: "Landcode", // translated
  chooseTicket: "Kies de bezorgmethode voor tickets", // translated
  ticketError: "Selecteer een ticket voor alle bestemmingen", // translated
  ticketDelivery: "Selecteer een bezorgmethode voor het ticket", // translated
  passengerDetails: "Passagier details", // translated
  waitWhileProcessingPayment: "Een ogenblik geduld terwijl we uw betaling verwerken. Vernieuw of sluit de pagina niet.", // translated
  reductionCardId: "Kortingskaart ID", // translated
  countryOfResidence: "Land van verblijf", // translated
  countryOfBirth: "Geboorteland", // translated
  documentCountry: "Documentland", // translated
  documentNumber: "Document Nummer", // translated
  expirationDate: "Uiterste houdbaarheidsdatum", // translated
  documentType: "Type document", // translated
  travelerDocumentInfo: "Informatie over reizigersdocumenten", // translated
  youth: "Jeugd", // translated
  youths: "Jongeren", // translated
  departTimeEarlyFirst: "Vertrektijd (vroegste eerst)", // translated
};


export default trains;
